import React from 'react'

const LoaderComponent = () => {
  return (
    <div className='d-flex justify-content-center align-items-center loader-style'>
      <div className='spinner-border text-primary' role='status'>
        <span className='visually-hidden'>Loading...</span>
      </div>
    </div>
  )
}

export default LoaderComponent
